import React from 'react';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';

//Styles
import './radiobutton.scss';

const RadioButton = (props) => {
    const { onChange, value, position, label, disabled } = props;

    return (
        <div className='radio-button-container'>
            <FormControlLabel
                style={{ marginLeft: 0 }}
                value={true}
                control={
                    <Radio
                        onClick={(e) => {
                            const { checked } = e.target
                            onChange(checked)
                        }}
                        checked={value} 
                        color="primary"
                    />
                }
                label={label || ''}
                labelPlacement={position || 'end'}
                disabled={disabled || false}
            />
        </div>
    )
}

export default RadioButton;